import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const PrimeTableFooter = ({rowDataList,btnReadMore,isShowMore=true,disabled=false}) => {

    const { t } = useTranslation();

    if (rowDataList?.length > 0) {
        return (
          <div className="table-footer">
            <span className="font-bold">{t('row_count')}: {rowDataList?.length}</span>
            {
                isShowMore? ( <button disabled={disabled} type="button" className="btn-more" onClick={btnReadMore}>{t('button.more')}
              </button>):(<></>)
            }
           
          </div>
        )
  
      }else{
        return (
          <div>
             {t('no_rec')}
          </div>
        )
      }
}

export default PrimeTableFooter;